import type { SubmitHandler } from 'react-hook-form';

import type { IApiGetAppUserResponseBody } from '~/lib/api/modules/Apps';
import type { IUseAddAppUserMutationValues } from '~/lib/api/modules/Apps/hooks/useAddAppUserMutation';
import type { IAppUserFormProps, IAppUserFormValues } from './AppUserForm';
import { ContentBlock } from '~/components/molecules/ContentBlock';
import { useAddAppUserMutation } from '~/lib/api/modules/Apps/hooks/useAddAppUserMutation';
import { useAppQuery } from '~/lib/api/modules/Apps/hooks/useAppQuery';
import { AppUserForm } from './AppUserForm';

export type IAddAppUserFormProps = Omit<
  IAppUserFormProps,
  'mode' | 'organizationId'
> & {
  onSuccess?: (
    outputData: IApiGetAppUserResponseBody,
    inputValues: IUseAddAppUserMutationValues,
  ) => void;
  cancelUrl?: string;
  appId: string;
};

export const AddAppUserForm: React.FC<IAddAppUserFormProps> = (props) => {
  const { sx, onSuccess, cancelUrl, appId } = props;
  const appAddUserMutation = useAddAppUserMutation();
  const appQuery = useAppQuery({ appId });

  const handleSubmit: SubmitHandler<IAppUserFormValues> = (values) => {
    if (appAddUserMutation.isLoading) {
      return;
    }

    return appAddUserMutation.mutateAsync(
      {
        appId,
        body: {
          userId: values.userId ?? '',
          roles: values.roles ?? ['viewer'],
        },
      },
      { onSuccess },
    );
  };

  return (
    <ContentBlock sx={sx}>
      <ContentBlock.Suspense
        loading={appQuery.isLoading}
        error={appQuery.error}
        first
      >
        {appQuery.data?.organization?._id ? (
          <AppUserForm
            first
            mode="creation"
            cancelUrl={cancelUrl}
            onSubmit={handleSubmit}
            organizationId={appQuery.data?.organization?._id}
          />
        ) : null}
      </ContentBlock.Suspense>
    </ContentBlock>
  );
};
